import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { handleChangeAll as handleChangeAllAction } from "../../../actions/handleChangeAction";
import { getMiljogebyrer as getMiljogebyrerAction } from "../../../actions/miljogebyrerActions";
import { getMiljoleveringstyper as getMiljoleveringstyperAction } from "../../../actions/miljoleveringstyperActions";
import { getOvertredelseskoderMiljogebyr as getOvertredelseskoderMiljogebyrAction } from "../../../actions/overtredelseskoderMiljogebyrActions";
import {
  getIleggelseQueryParameters,
  getMiljogebyrTableRows,
} from "../../../selectors/miljogebyrerSelector";
import Utskrift from "../Utskrift";

import { miljogebyr as miljogebyrTitle } from "../../../constants/titles";

const miljogebyrTableHeaders = [
  "Ilegg.nr.",
  "Ilegg.dato",
  "Klokkeslett",
  "Tjenestenr.",
  "Overt.kode",
  "Mottaker",
  "Gatenavn",
  "Gatenr.",
  "Ved",
  "Ved nr.",
  "GNR",
  "BNR",
  "Bilde",
];

function UtskriftContainer(props) {
  const dispatch = useDispatch();
  const queryParameters = useSelector(getIleggelseQueryParameters);
  const miljogebyrTableRows = useSelector(getMiljogebyrTableRows);
  const getMiljogebyrer = useCallback(
    (params, page, count) =>
      dispatch(getMiljogebyrerAction(params, page, count)),
    [dispatch],
  );
  const handleChangeAll = useCallback(
    (payload) =>
      dispatch(
        handleChangeAllAction("MILJOGEBYRER_OVERSIKT_FILTER_FORM", payload),
      ),
    [dispatch],
  );
  const getOvertredelseskoderMiljogebyr = useCallback(
    () => dispatch(getOvertredelseskoderMiljogebyrAction()),
    [dispatch],
  );
  const getMiljoleveringstyper = useCallback(
    () => dispatch(getMiljoleveringstyperAction()),
    [dispatch],
  );

  return (
    <Utskrift
      {...props}
      queryParameters={queryParameters}
      miljogebyrTableHeaders={miljogebyrTableHeaders}
      miljogebyrTableRows={miljogebyrTableRows}
      getMiljogebyrer={getMiljogebyrer}
      handleChangeAll={handleChangeAll}
      getOvertredelseskoderMiljogebyr={getOvertredelseskoderMiljogebyr}
      getMiljoleveringstyper={getMiljoleveringstyper}
      title="Miljøgebyroversikt"
      documentTitle={miljogebyrTitle.miljogebyroversikt}
    />
  );
}

export default UtskriftContainer;
